<pxw-modal-form
  #modalForm
  [title]="title()"
  modalStyle="fullscreen"
  modalClasses="ui-popup"
  (modalOpen)="onModalOpenToggle($event)"
>
  <!-- NOTE: this is transcluded through "custom-action" class selection -->
  <pxw-button
    class="custom-action"
    color="blue"
    [rounded]="true"
    size="md"
    [disabled]="!isDirty()"
    icon="check"
    (click)="onReady()"
  >
    {{ readyText() }}
  </pxw-button>
  <ng-template #modalContent>
    <div class="map-content">
      @let instructions = mapInstructions();

      @if (instructions && instructions.length > 0 && displayInstructions()) {
        <pxw-alert
          type="info"
          display="inline-block"
          size="sm"
          class="map-instructions"
          [displayCloseButton]="true"
          (closeAlert)="displayInstructions.set(false)"
        >
          @for (instruction of mapInstructions(); track instruction) {
            <p class="map-instruction">- {{ instruction }}</p>
          }
        </pxw-alert>
      }

      <div class="map-wrapper" [ngClass]="{ loading: loadingLocation() }">
        <pxw-stadia-maps
          [center]="center()"
          [zoom]="zoom()"
          [displayMyLocationButton]="true"
          [geolocationErrorText]="geolocationErrorText()"
          (mapClick)="onMapClick($event)"
          (geolocationResult)="onGeolocationResult($event)"
        >
          @if (markerCopy()) {
            <ng-template #mapContents>
              <pxw-stadia-maps-marker
                [lat]="markerCopy()!.lat"
                [lng]="markerCopy()!.lng"
                [draggable]="true"
                (markerDragEnd)="onMarkerDragend($event)"
              />
            </ng-template>
          }
        </pxw-stadia-maps>
      </div>
      @if (loadingLocation()) {
        <div class="ui-loader">
          <pxw-icon icon="loading" [spin]="true"></pxw-icon>
        </div>
      }
    </div>
  </ng-template>
</pxw-modal-form>
